/**
 * VideoEpisodeForm - Form for adding individual video episodes
 */
import { Play, Plus, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';

export const VideoEpisodeForm = ({ 
  formData, 
  setFormData, 
  onSubmit, 
  onCancel, 
  adding 
}) => {
  return (
    <form onSubmit={onSubmit} className="bg-zinc-900 rounded-xl p-6 space-y-4 border border-white/10">
      <h3 className="text-white font-bold flex items-center gap-2">
        <Play className="w-5 h-5 text-red-500" />
        Add Video Episode
      </h3>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">YouTube Video URL *</label>
        <input
          type="url"
          value={formData.youtube_url}
          onChange={(e) => setFormData({ ...formData, youtube_url: e.target.value })}
          placeholder="https://youtube.com/watch?v=..."
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          required
          data-testid="episode-youtube-url"
        />
      </div>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">Episode Title *</label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          placeholder="Episode title"
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          required
        />
      </div>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">Description</label>
        <textarea
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Episode description..."
          rows={2}
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
        />
      </div>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">Custom Thumbnail URL (optional)</label>
        <input
          type="url"
          value={formData.thumbnail_url}
          onChange={(e) => setFormData({ ...formData, thumbnail_url: e.target.value })}
          placeholder="Leave blank to use YouTube thumbnail"
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
        />
      </div>

      <div className="flex gap-2 pt-2">
        <Button type="submit" disabled={adding} className="bg-red-600 hover:bg-red-700">
          {adding ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Plus className="w-4 h-4 mr-2" />}
          Add Episode
        </Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default VideoEpisodeForm;
